import { render, staticRenderFns } from "./HoldingExposure.vue?vue&type=template&id=146f3c00&scoped=true&"
import script from "./HoldingExposure.vue?vue&type=script&lang=js&"
export * from "./HoldingExposure.vue?vue&type=script&lang=js&"
import style0 from "./HoldingExposure.vue?vue&type=style&index=0&id=146f3c00&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146f3c00",
  null
  
)

export default component.exports